export const FlagRUIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21_259)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M23.2539 16.1733C23.7363 14.8734 24.0003 13.4673 24.0003 11.9995C24.0003 10.5316 23.7363 9.12555 23.2539 7.82556H0.746665C0.264322 9.12555 0.000274658 10.5316 0.000274658 11.9995C0.000274658 13.4673 0.264322 14.8734 0.746665 16.1733L12.0003 17.2168L23.2539 16.1733Z"
          fill="#0052B4"
        />
        <path
          d="M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.2539 16.1734H0.746719C2.44223 20.743 6.84075 23.9995 12.0003 23.9995Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_259">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
